import { ReactNode, createContext, useEffect, useState } from "react";

export type ThemeColors = {
  colorPrimary: string;
  colorSecondary: string;
  colorBackground: string;
  colorText: string;
  colorOverlay: string;
};

export type ThemeType = "light" | "dark";

export type Themes = Record<ThemeType, ThemeColors>;

export const themes: Themes = {
  light: {
    colorPrimary: "#FFCC02",
    colorSecondary: "#ff8902ff",
    colorBackground: "#FFFFFF",
    colorText: "#000000",
    colorOverlay: "#EDEDED",
  },
  dark: {
    colorPrimary: "#FFCC02",
    colorSecondary: "#ff8902ff",
    colorBackground: "#000000",
    colorText: "#FCFDFD",
    colorOverlay: "#1E1E1E",
  },
};

export const ThemeContext = createContext<{
  theme: ThemeType;
  toggleTheme: () => void;
  colorsObj: ThemeColors;
}>({ theme: "dark", colorsObj: themes["dark"], toggleTheme: () => {} });

export const ThemeProvider = ({ children }: { children: ReactNode }) => {
  const [currentTheme, setCurrentTheme] = useState<ThemeType>("dark");
  const [colorsObj, setColorsObj] = useState<ThemeColors>(themes["dark"]);

  // useEffect(() => {
  //   try {
  //     const raw = localStorage.getItem("theme");
  //     const parsed = raw ? JSON.parse(raw) : null;

  //     if (
  //       (parsed.name && parsed?.name === "light") ||
  //       parsed?.name === "dark"
  //     ) {
  //       setCurrentTheme(parsed.name);
  //       setColorsObj(themes[parsed.name as ThemeType]);
  //     }
  //   } catch (e) {
  //     console.warn("Invalid theme in localStorage");
  //   }
  // }, []);

  const toggleTheme = () => {
    setCurrentTheme((prevTheme) => {
      const newTheme = prevTheme === "light" ? "dark" : "light";
      setColorsObj(themes[newTheme]);
      localStorage.setItem("theme", JSON.stringify({ name: newTheme }));
      return newTheme;
    });
  };

  return (
    <ThemeContext.Provider
      value={{ theme: currentTheme, toggleTheme, colorsObj }}
    >
      {children}
    </ThemeContext.Provider>
  );
};
